module.exports = __webpack_public_path__ + "static/img/menu-about-consultation.6e1a0595.png";